var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 188,
    viewBox: "0 0 199 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 199,
    height: 188,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 188
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset_16_1_2_",
    "data-name": "Asset 16 1 (2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M101.7,2.617,40.413,28.551,15.457,90.131,41.451,151.28l61.714,24.9,61.29-25.935,24.956-61.58L163.416,27.523Z",
    fill: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M73.434,144.118s5.079,19.135,0,29.436l-3.881,6.489a90.081,90.081,0,0,0,27.533,7.533,63.852,63.852,0,0,0,28.67-3.055s-1.016-5.884-1.835-17.827a54.455,54.455,0,0,1,3.768-22.569",
    fill: "#4f82df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M114.165,57.216a12.7,12.7,0,0,1,11.264,9.825c1.6,6.391,5.694,6.451,7.558,9.636s3.9,7.745.478,15.354c-.978,2.178-5.784,4.387-4.927,6.572s3.381,6.346,1.1,9.87-9.34,5.022-9.772,6.195-39.639-.87-40.988-2.458-5.329-12.17.424-14.734-.318-8.925-1.5-11.315-4.177-8.3-.424-12.918c4.639-5.718,7.383-4.909,6.959-8.758s2.168-3.071,6.155-4.031,3.677-5.438,6.247-5.967,4.707,2.352,6.58,1.392,6.9-4.735,10.848,1.354Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M30.109,28.841l-2.6,1.1a1.64,1.64,0,0,0-.872,2.152l1.1,2.59a1.646,1.646,0,0,0,2.157.87l2.6-1.1a1.64,1.64,0,0,0,.872-2.152l-1.1-2.59A1.646,1.646,0,0,0,30.109,28.841Z",
    fill: "#4069dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M50.29,119.341l-.47-.205a.387.387,0,0,1-.2-.514l.2-.469a.388.388,0,0,0-.2-.514l-1.016-.431a.39.39,0,0,0-.515.2l-.2.469a.389.389,0,0,1-.515.2l-.47-.2a.39.39,0,0,0-.515.2l-.432,1.014a.388.388,0,0,0,.2.514l.47.2a.388.388,0,0,1,.2.514l-.2.469a.389.389,0,0,0,.2.515l1.016.431a.39.39,0,0,0,.515-.2l.2-.469a.39.39,0,0,1,.515-.205l.47.205a.389.389,0,0,0,.515-.205l.432-1.013A.387.387,0,0,0,50.29,119.341Z",
    fill: "#f18339"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M181.739,59.175l-.47.2a.4.4,0,0,1-.516-.2l-.2-.469a.389.389,0,0,0-.515-.2l-1.016.431a.388.388,0,0,0-.2.514l.2.469a.394.394,0,0,1-.2.514l-.47.2a.388.388,0,0,0-.205.514l.432,1.014a.39.39,0,0,0,.516.2l.47-.2a.4.4,0,0,1,.515.2l.2.469a.39.39,0,0,0,.516.2L181.8,62.6a.388.388,0,0,0,.2-.514l-.2-.469a.4.4,0,0,1,.2-.514l.47-.2a.388.388,0,0,0,.205-.514l-.433-1.013A.389.389,0,0,0,181.739,59.175Z",
    fill: "#b280d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M153.925,98.791l-.47.2a.4.4,0,0,1-.515-.2l-.2-.469a.39.39,0,0,0-.516-.2l-1.015.431a.387.387,0,0,0-.205.514l.2.469a.4.4,0,0,1-.205.514l-.47.2a.388.388,0,0,0-.2.514l.432,1.014a.389.389,0,0,0,.515.2l.47-.2a.4.4,0,0,1,.516.2l.2.469a.39.39,0,0,0,.515.205l1.016-.432a.388.388,0,0,0,.205-.514l-.2-.469a.393.393,0,0,1,.2-.514l.47-.2a.388.388,0,0,0,.205-.514L154.441,99A.39.39,0,0,0,153.925,98.791Z",
    fill: "#fb5f22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M117.1,35l-3.856-.56a2.258,2.258,0,0,0-2.561,1.906l-.561,3.847a2.254,2.254,0,0,0,1.91,2.555l3.856.56a2.258,2.258,0,0,0,2.561-1.906l.561-3.847A2.255,2.255,0,0,0,117.1,35Z",
    fill: "#edbe03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M86.253,16.049,77.08,44.555c-.053.166-.387.212-.751.1s-.606-.348-.553-.514l9.173-28.506,1.3.416Z",
    fill: "#4f82df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M99.436,14.6,93.765,44c-.03.174-.364.257-.728.189s-.644-.272-.606-.446l5.67-29.4,1.342.257Z",
    fill: "#4f82df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M92.567,5.173,77.194,30.881c-.091.151-.424.121-.751-.076s-.515-.469-.424-.62L91.393,4.477l1.167.7Z",
    fill: "#4f82df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M86.594.287,79.976,26.766l6-.915L92.037.968Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M86.8.31,80.181,26.8l6-.915L92.242,1Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M87,.34l-6.61,26.487,6-.915L92.446,1.029Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M87.2.371,80.59,26.85l6-.908L92.643,1.059Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M87.678.431l16.738,2.231s-3.267,10.173-2.691,16.828a36.8,36.8,0,0,0,1.349,6.27l-16.715,1.2S82.023,16.707,87.67.424Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M103.924,4.326,86.746,2.193l-.7-.219L86.549,0l.887.151,16.98,2.511Z",
    fill: "#4f82df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M99.216,18.961l-10.658.181c-1.327-3.706.47-11.708.47-11.708",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M99.216,18.961l-10.658.181c-1.327-3.706.47-11.708.47-11.708",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M89.414,14.96,99.436,14.6",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M89.452,17.025l10.014-.348",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M89.763,12.018l9.832.265",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M89.133,18.613s7.922-1.482,10.423-8.214",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M98.563,11.02l1.069-.84-.1,1.331",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M75.284,154.434l-8.566,7.836c.167-15.7-10.325-28.5-10.325-28.5s2.782-5.082,10.325-15.164c7.429-9.938,23.765-14.718,23.765-14.718s10.491,8.017,17.049,9.651,4.1-4.826,4.1-4.826l-1.478-4.825a75.4,75.4,0,0,1,20.49,15.376c9.673,10.3,11.97,13.735,11.97,13.735a52.076,52.076,0,0,0-7.376,15.376c-2.949,9.651-2.13,15.043-2.13,15.043l-8.8-6.368",
    fill: "#4f82df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M75.284,154.434l-8.566,7.836c.167-15.7-10.325-28.5-10.325-28.5s2.782-5.082,10.325-15.164c7.429-9.938,23.765-14.718,23.765-14.718s10.491,8.017,17.049,9.651,4.1-4.826,4.1-4.826l-1.478-4.825a75.4,75.4,0,0,1,20.49,15.376c9.673,10.3,11.97,13.735,11.97,13.735a52.076,52.076,0,0,0-7.376,15.376c-2.949,9.651-2.13,15.043-2.13,15.043l-8.8-6.368",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M125.763,184.513s-1.016-5.884-1.835-17.826a54.45,54.45,0,0,1,3.768-22.569",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M73.434,144.118s5.079,19.135,0,29.436l-3.881,6.489",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M139.333,154.79s-4.632,11.367-6.232,8.629,1.327-12.161,1.327-12.161Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M64.709,149.745a35.535,35.535,0,0,1,2,12.525c-.068,1.089-4.889-5.461-4.889-5.461l2.881-7.064Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M142.615,132.992s7.6,11.065,8.907,11.118,15.957-7.8,18.36-12.592,2.4-13.085,2.623-16.572,4.374-9.159,6.118-8.72-3.275,6.1-1.963,8.5,6.117,0,6.337-3.267-3.335-3.162-3.389-4.251.652-1.747,2.623-1.361A5.458,5.458,0,0,1,186.06,112c-.432,3.374,4.26-3.6,3.934-6.27s.326-4.091,1.311-3.758,1.092,5.884,0,8.614l-1.091,2.723s2.517-4.031,2.623-6.762.765-3.6,1.857-3.161,0,6.542-.652,8.289a13.716,13.716,0,0,1-1.418,2.836,17.36,17.36,0,0,0,3.389-4.795c.872-2.284,1.963-2.291,2.623-1.747s-.986,5.559-1.751,6.868-5.026,7.412-7.869,9.484-6.118,3.706-7.975,7.193-15.411,25.73-28.632,29.436-17.966-9.7-17.966-9.7,1.554-10.528,8.187-18.258Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M56.393,133.771s-7.6,11.065-8.907,11.118-15.957-7.8-18.36-12.592-2.4-13.085-2.623-16.572-4.374-9.159-6.118-8.72,3.275,6.1,1.963,8.5-6.118,0-6.337-3.267,3.336-3.162,3.389-4.251-.652-1.747-2.623-1.361a5.458,5.458,0,0,0-3.828,6.156c.432,3.374-4.26-3.6-3.934-6.27s-.326-4.091-1.311-3.759-1.092,5.885,0,8.615l1.092,2.723s-2.517-4.031-2.623-6.762-.766-3.6-1.857-3.161,0,6.542.652,8.289a13.726,13.726,0,0,0,1.418,2.836A17.358,17.358,0,0,1,2.994,110.5c-.872-2.284-1.963-2.291-2.623-1.747s.985,5.559,1.751,6.868,5.026,7.412,7.869,9.484,6.118,3.706,7.975,7.193,15.412,25.73,28.632,29.436,18.633-10.226,18.633-10.226-2.828-10.664-8.854-17.743Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M101.785,73.712l10.871-2.292,4.783-5.264s5.868,16.079,3.465,23.7c-2.509,7.957-5.966,9.136-9.12,8.8a11.232,11.232,0,0,1-4.2-1.672s1.675,5.234,3.2,8.917c.356.87,2.259,4.622,1.038,6.611-.523.862-2.767,1.89-5.132,1.134-4.723-1.512-16.2-9.779-16.2-9.779l5.284-16.586",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M101.785,73.712l10.871-2.292,4.783-5.264s5.868,16.079,3.465,23.7c-2.509,7.957-5.966,9.136-9.12,8.8a11.232,11.232,0,0,1-4.2-1.672s1.675,5.234,3.2,8.917c.356.87,2.259,4.622,1.038,6.611-.523.862-2.767,1.89-5.132,1.134-4.723-1.512-16.2-9.779-16.2-9.779l5.284-16.586",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M117.182,65.513c3.335,5.43.257,9.326-5.072,10.921s-8.081-1.566-8.081-1.566-4.215,5.257-8.513.681",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M117.182,65.513c3.335,5.43.257,9.326-5.072,10.921s-8.081-1.566-8.081-1.566-4.215,5.257-8.513.681",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M96.509,87.923s-6.156-4.137-6.914-8.191,1.387-5.7,3.138-5.635a3.308,3.308,0,0,1,2.79,1.445",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M96.509,87.923s-6.156-4.137-6.914-8.191,1.387-5.7,3.138-5.635a3.308,3.308,0,0,1,2.79,1.445",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M107.463,96.454l1.319,4.7s-4.707-2.058-6.693-5.332a12.585,12.585,0,0,1-2.07-5.362A81.308,81.308,0,0,0,107.463,96.454Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M92.408,78.484a8.833,8.833,0,0,1,3.646,3.676Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M92.408,78.484a8.833,8.833,0,0,1,3.646,3.676",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M93.378,81l2.062.106",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M111.906,78.393a.842.842,0,0,1,.394.862c-.053.3-.159.643-.372.7-.4.1-3.3-1.157-5.048-.681a26.545,26.545,0,0,0-3.791,1.46A8.3,8.3,0,0,1,107.88,77.9a5.427,5.427,0,0,1,4.033.492Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M116.583,77.939a.94.94,0,0,0-.576,1.066.462.462,0,0,0,.227.363c.334.121,2.926-.7,4.389-.144a22.574,22.574,0,0,1,3.124,1.581,7.153,7.153,0,0,0-3.859-2.844,4.89,4.89,0,0,0-3.3-.023Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M116.083,85.556s1.3,4.092.879,4.78-2.395,0-2.63-.439",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M116.083,85.556s1.3,4.092.879,4.78-2.395,0-2.63-.439",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M109.229,91.326a3.464,3.464,0,0,0,4.936,2.579Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M109.229,91.326a3.464,3.464,0,0,0,4.936,2.579",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M105.272,82.485a4.911,4.911,0,0,0,6.429,1.066Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M105.272,82.485a4.911,4.911,0,0,0,6.429,1.066",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M117.038,82.984s2.372,1.944,4.434.333Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M117.038,82.984s2.372,1.944,4.434.333",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M161.182,66.468,156.307,65.1a.532.532,0,0,0-.655.367l-2.443,8.68a.529.529,0,0,0,.367.653l4.875,1.366a.532.532,0,0,0,.655-.367l2.443-8.679A.529.529,0,0,0,161.182,66.468Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M160.591,66.686l-4.875-1.366a.53.53,0,0,0-.654.367l-2.444,8.679a.529.529,0,0,0,.367.653l4.875,1.366a.531.531,0,0,0,.655-.367l2.444-8.679A.53.53,0,0,0,160.591,66.686Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M154.084,67.646l.111.931a.439.439,0,0,0,.488.384l36.384-4.3a.439.439,0,0,0,.385-.487l-.111-.931a.439.439,0,0,0-.488-.384l-36.384,4.3A.439.439,0,0,0,154.084,67.646Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M153.81,68.049l.111.931a.439.439,0,0,0,.488.384l36.384-4.3a.439.439,0,0,0,.385-.487l-.111-.931a.439.439,0,0,0-.488-.384l-36.384,4.3A.439.439,0,0,0,153.81,68.049Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M156.446,67.3l.214,1.8,6.331-.748-.214-1.8Z",
    fill: "#4f82df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M169.052,65.808l.214,1.8,6.331-.748-.214-1.8Z",
    fill: "#4f82df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M181.651,64.323l.214,1.8,6.331-.748-.214-1.8Z",
    fill: "#4f82df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M153.809,68.034l.114.961a.423.423,0,0,0,.471.371l36.414-4.3a.423.423,0,0,0,.371-.47l-.114-.961a.423.423,0,0,0-.471-.371l-36.414,4.3A.424.424,0,0,0,153.809,68.034Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M13.039,72.842l3.586,14.484,1.258-.31L14.524,73.469",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M13.039,72.842l3.586,14.484,1.258-.31L14.524,73.469",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M13.031,64.106,16.625,78.59l1.251-.31L14.517,64.734",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M13.031,64.106,16.625,78.59l1.251-.31L14.517,64.734",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M41.079,59.939l2.941,11.889-1.251.31L39.412,58.592",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M41.079,59.939l2.941,11.889-1.251.31L39.412,58.592",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M44.627,65.052l3.593,14.484-1.258.31L43.6,66.292",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M44.627,65.052l3.593,14.484-1.258.31L43.6,66.292",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M44.625,65.052,13.032,72.841l.346,1.4,31.593-7.789Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M44.627,65.052l-31.589,7.79-.083-9.189L39.472,57.11Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M27.783,65.13c1.658-.409,2.871-1.27,2.71-1.922s-1.637-.851-3.3-.442-2.872,1.27-2.71,1.922S26.125,65.539,27.783,65.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M24.72,61.058c.3.3,2.919-.023,4.124-1.248C30.413,58.215,23.993,60.31,24.72,61.058Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M27.336,61.051A75.408,75.408,0,0,0,24.7,53.888c-.857-1.6-1.834-1.83-1.683-.787C23.265,54.826,25.441,58.767,27.336,61.051Z",
    fill: "#edbe03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M24.591,55.4l2.744,5.65",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M27.351,61.338s-1.334-4.931-1.236-6.308,1.054-1.853,1.721-.923-.364,6.747-.485,7.238Z",
    fill: "#edbe03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M27.085,55.6l.3,5.5",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M27.419,61.255s-3.464-6.172-5-5.665S24.523,59.878,27.419,61.255Z",
    fill: "#edbe03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M27.419,61.255s-3.965-3.237-5.382-2.753S25.342,61.482,27.419,61.255Z",
    fill: "#edbe03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M27.51,61.232s3.01-4.137,2.449-5.521S27.162,59.175,27.51,61.232Z",
    fill: "#edbe03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M23.379,56.861,27.3,61.172,22.833,59.3",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M29.367,56.936l-1.948,4.319",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M26.722,64.212c.728.363,2.661-.159,2.919-1.082s-.553-3.751-.553-3.751a3.679,3.679,0,0,1-2.282,1.467,5.009,5.009,0,0,1-2.138.129s1.258,2.851,2.054,3.245Z",
    fill: "#4f82df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M27.973,129.143s1.243,13.387-4.639,13.061-2.714-5.528-2.714-5.528",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M29.481,132.894a3.025,3.025,0,0,1,3.252,1.051c1.327,1.7.917,5.31-1.63,9.47s-6.7,3.343-7.186,2.276,1.069-2.677,1.069-2.677",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M182.99,111.46a3.23,3.23,0,0,0,1.72,0,3.459,3.459,0,0,0,1.38-.643l-.182-1.165a6.478,6.478,0,0,1-1.69.492l-1.342.121.114,1.195Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.61
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.88b9d013.svg";
export { ForwardRef as ReactComponent };